/*jshint esversion: 11 */

window.header = () => {
    "use strict";
    return {
        mobileOpen: window.innerWidth >= 1272,
        initialWidth: window.innerWidth.toString(),
        callToProducersOpen: localStorage.getItem('callToProducersOpen') === 'true' || !(localStorage.getItem('callToProducersOpen') === 'false' || !(window.innerWidth <= 1272)),
        init() {
            window.addEventListener('resize', () => {
                if (this.initialWidth !== window.innerWidth.toString()) {
                    this.mobileOpen = window.innerWidth >= 1272;
                }
            });
            this.$watch('callToProducersOpen', function (value) {
                localStorage.setItem('callToProducersOpen', value);
                if (value) {
                    document.getElementById('hero').classList.add('pt-40');
                    document.getElementById('hero').classList.remove('pt-32');
                } else {
                    document.getElementById('hero').classList.remove('pt-40');
                    document.getElementById('hero').classList.add('pt-32');
                }
            });
        },
    };
};

